const routes = [
    {
        path: "dashboard-default",
        name: "AdminDashboard",
        component: () => import('@/modules/admin/views/Dashboard.vue'),
    },
    {
        path: "permisos",
        name: "Permisos",
        component: () => import('@/modules/admin/views/permisos/Permisos.vue'),
    },
    {
        path: "usuarios",
        name: "Usuarios",
        component: () => import('@/modules/admin/views/usuarios/Usuarios.vue'),
    },
    {
        path: "proveedores",
        name: "Proveedores",
        component: () => import('@/modules/admin/views/proveedores/Proveedores.vue'),
    },
    {
        path: "cuentas",
        name: "Cuentas",
        component: () => import('@/modules/admin/views/cuentas/Cuentas.vue'),
    },
    {
        path: "clientes",
        name: "Clientes",
        component: () => import('@/modules/admin/views/clientes/Clientes.vue'),
    },
    {
        path: "laminas",
        name: "laminas",
        component: () => import('@/modules/admin/views/laminas/Laminas.vue'),
    },
    {
        path: "reportes",
        name: "reportes",
        component: () => import('@/modules/admin/views/reportes/Reportes.vue'),
    },
];

export default routes;